import { createFileRoute } from '@tanstack/react-router';

// Matches old `/compare/*` links (e.g. report emails) so the parent `/compare`
// route's redirect applies to them too.
export const Route = createFileRoute('/compare/$')({});
